<template>
  <el-dialog
    title="新增"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :visible.sync="dialogFormVisible"
    width="50%"
    @close="closeDialog"
  >
    <el-form
      ref="form"
      label-position="right"
      :model="form"
      :rules="rules"
      :label-width="formLabelWidth"
      id="form"
    >
      <el-form-item label="分类名称" prop="merchantName">
        <el-col :span="18">
          <el-input 
            v-model.trim="form.merchantName"
            placeholder="请输入分类名称"
            :maxlength="50"
            show-word-limit
          ></el-input>
        </el-col>
      </el-form-item>
      <!-- <el-form-item label="联系人" prop="contacts">
        <el-col :span="18">
          <el-input clearable v-model.trim="form.contacts"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="联系电话" prop="telephone">
        <el-col :span="18">
          <el-input clearable v-model.trim="form.telephone"></el-input>
        </el-col>
      </el-form-item> -->
      <el-form-item label="图片" prop="picture">
        <el-col :span="18">
          <el-upload
            ref="upload"
            class="avatar-uploader"
            action="/api/tool/oss/upload"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :on-change="beforeAvatarUpload"
            :auto-upload="false"
            :before-upload="validateImage"
          >
            <img v-if="imgUrl" :src="imgUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-col>
      </el-form-item>
      <el-form-item class="crop">
        <el-col :span="18">
          <div class="cropper-container">
            <template>
              <vue-cropper
                ref="cropper"
                :aspect-ratio="1"
                :src="imgUrl"
                preview=".preview"
                :view-mode="2"
                :drag-mode="'move'"
                :auto-crop-area="1"
                :crop-box-movable="true"
                :crop-box-resizable="false"
              />
              <div v-if="!imgUrl" class="cropper-placeholder">裁剪区</div>
              <el-button 
                type="primary" 
                v-if="imgUrl" 
                @click="cropImage"
                :loading="isCropping"
              >
                裁剪
              </el-button>
            </template>
          </div>
        </el-col>
      </el-form-item>
      <!-- <el-form-item label="跳转url" prop="url">
        <el-col :span="18">
          <el-input clearable v-model.trim="form.url"></el-input>
        </el-col>
      </el-form-item> -->
      <el-form-item label="备注" prop="remark">
        <el-col :span="18">
          <el-input
            type="textarea"
            v-model.trim="form.remark"
            :maxlength="200"
            show-word-limit
            placeholder="请输入备注信息"
          ></el-input>
        </el-col>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog('normal')">取 消</el-button>
      <el-button 
        type="primary" 
        @click="handleSubmit"
        :loading="isSubmitting"
      >
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { shopMerchantCategoryAdd } from "@/api/url";
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  name: "merchant-class-add",
  components: {
    VueCropper,
  },
  data() {
    return {
      dialogFormVisible: true,
      form: {
        merchantName: "",
        contacts: "",
        telephone: "",

        picture: "",
        url: "",
        remark: "",
      },
      rules: {
        // merchantName: [
        //   { required: true, message: '请输入分类名称', trigger: 'blur' },
        //   { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        // ],
        // picture: [
        //   { required: true, message: '请上传图片', trigger: 'change' }
        // ]
      },
      formLabelWidth: "120px",
      imgUrl: "",
      isSubmitting: false,
      isCropping: false,
      maxFileSize: 5 * 1024 * 1024, // 5MB
    };
  },
  methods: {
    closeDialog(type) {
      this.$emit("closeDialog", type);
    },
    validateImage(file) {
      const isImage = file.type.startsWith('image/');
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate();
        this.isSubmitting = true;
        await this.uploadImage();
        await this.submitForm();
      } catch (error) {
        console.error('Form submission error:', error);
      } finally {
        this.isSubmitting = false;
      }
    },
    async submitForm() {
      try {
        const { merchantName, picture, remark } = this.form;
        const res = await this.$postRequest(shopMerchantCategoryAdd(), {
          name:merchantName,
          icon: picture,
          description: remark,
        });
        if (res.status === 200) {
          this.$message.success('新增成功');
          this.closeDialog('add');
        } else {
          throw new Error(res.message || '新增失败');
        }
      } catch (error) {
        throw error;
      }
    },
    /**
     * 处理头像上传成功的回调
     *
     * @param res 上传成功后的响应对象
     */
    handleAvatarSuccess(res) {
      if (res?.data) {
        this.form.picture = res.data;
      }
    },
    beforeAvatarUpload(f) {
      const file=f.raw 
      if (!this.validateImage(file)) return;
      
      this.fileList = [file];
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgUrl = event.target.result;
          this.$refs.cropper?.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        this.$message.error('您的浏览器不支持 FileReader');
      }
    },
    async uploadImage() {
      if (!this.$refs.cropper) return;
      
      return new Promise((resolve, reject) => {
        this.$refs.cropper.getCroppedCanvas({
          width: 100,
          height: 100
        }).toBlob(
          async (blob) => {
            try {
              const file = new File([blob], 'cropped-image.jpg', {
                type: 'image/jpeg',
              });
              const formData = new FormData();
              formData.append('file', file);
              formData.append('pathName', 'coupon');

              const response = await fetch('/api/tool/oss/upload', {
                method: 'POST',
                body: formData,
              });
              const data = await response.json();
              
              if (data?.data) {
                this.form.picture = data.data;
                this.$message.success('图片上传成功');
                resolve(data);
              } else {
                throw new Error('图片上传失败');
              }
            } catch (error) {
              reject(error);
            }
          },
          'image/jpeg',
          0.9
        );
      });
    },
    cropImage() {
      this.isCropping = true;
      try {
        this.imgUrl = this.$refs.cropper.getCroppedCanvas().toDataURL();
      } catch (error) {
        console.error(error);
      } finally {
        this.isCropping = false;
      }
    },
  },
};
</script>

<style scoped>
.avatar {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

.cropper-container {
  box-sizing: border-box;
  padding: 20px;
  width: 100%;
  height: 80%;
  border: 1px dashed #ccc;
  border-radius: 10px;
  text-align: center;
  line-height: 50px;
}

.cropper-placeholder {
  color: #909399;
  font-size: 14px;
}

.avatar-uploader {

  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
</style>